// extracted by mini-css-extract-plugin
module.exports = {"info":"info__mPsZdhUtDMp8r","info_title":"info_title__VMvC7uogmKx6x","info_item":"info_item__rzDsLekE20XCb","info_icon":"info_icon__W9my6sm7UOFzG","line":"line__EIlOatCFg5I1s"};